export const heroSlides = [
  {
    mediaId: "tv9",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20ancient%20chinese%20palace%20city%20at%20night%20with%20thousands%20of%20glowing%20red%20lanterns%20mist%20over%20the%20rooftops%20warm%20amber%20and%20deep%20crimson%20tones%20majestic%20cinematic%20wide%20establishing%20shot%20rich%20detail%20no%20text&width=1600&height=900&seq=hero-tv9&orientation=landscape",
    slogan: "盛世长安，一眼千年",
  },
  {
    mediaId: "mv1",
    backdrop:
      "https://readdy.ai/api/search-image?query=vast%20science%20fiction%20space%20scene%20with%20a%20giant%20glowing%20blue%20planet%20rising%20over%20a%20dark%20horizon%20and%20a%20tiny%20spacecraft%20silhouette%20deep%20navy%20and%20teal%20tones%20with%20warm%20orange%20rim%20light%20epic%20cinematic%20wide%20composition%20no%20text&width=1600&height=900&seq=hero-mv1&orientation=landscape",
    slogan: "在星海尽头，找到回家的路",
  },
  {
    mediaId: "mv8",
    backdrop:
      "https://readdy.ai/api/search-image?query=mysterious%20deep%20ocean%20abyss%20with%20a%20submarine%20descending%20into%20darkness%20surrounded%20by%20faint%20bioluminescent%20glow%20and%20suspended%20particles%20deep%20navy%20and%20teal%20tones%20tense%20eerie%20cinematic%20wide%20composition%20no%20text&width=1600&height=900&seq=hero-mv8&orientation=landscape",
    slogan: "深海之下，回应的不止是信号",
  },
  {
    mediaId: "mv5",
    backdrop:
      "https://readdy.ai/api/search-image?query=enigmatic%20old%20town%20street%20shrouded%20in%20dense%20fog%20at%20dusk%20with%20dim%20glowing%20lanterns%20and%20wet%20cobblestones%20cold%20teal%20tones%20with%20faint%20amber%20accents%20moody%20cinematic%20wide%20composition%20no%20text&width=1600&height=900&seq=hero-mv5&orientation=landscape",
    slogan: "雾散之前，真相只有一个",
  },
  {
    mediaId: "mv7",
    backdrop:
      "https://readdy.ai/api/search-image?query=gritty%20war%20action%20scene%20of%20soldiers%20silhouetted%20against%20a%20smoky%20orange%20sunset%20in%20a%20desert%20with%20dust%20in%20the%20air%20dramatic%20orange%20and%20charcoal%20tones%20intense%20cinematic%20wide%20composition%20no%20text&width=1600&height=900&seq=hero-mv7&orientation=landscape",
    slogan: "守住防线，就是守住身后的一切",
  },
];